module.exports = __webpack_public_path__ + "img/bronze.d0765566.svg";